"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAdminOtp = exports.verifyOtp = exports.sendAdminOtp = exports.sendOtp = exports.resetPassword = exports.updateUserProfile = exports.update = exports.create = exports.fetchUserById = exports.fetchForFranchise = exports.fetchForOwner = exports.fetch = exports.getTokenWithRefreshToken = exports.getUserTokenWithRefreshToken = exports.logout = exports.businessLogin = exports.register = exports.fOwnerLogin = exports.adminLogin = exports.login = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const userService_1 = require("./service/userService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.login = (0, toolkit_1.createAsyncThunk)('user/login', (loginData, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.ownerLogin(loginData);
        return response;
    }
    catch (error) {
        throw new Error(error.message);
    }
}));
exports.adminLogin = (0, toolkit_1.createAsyncThunk)('user/adminLogin', (loginData, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.adminLogin(loginData);
        return response;
    }
    catch (error) {
        throw new Error(error.message);
    }
}));
exports.fOwnerLogin = (0, toolkit_1.createAsyncThunk)('user/fOwnerLogin', (loginData, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.franchiseOwnerLogin(loginData);
        return response;
    }
    catch (error) {
        throw new Error(error.message);
    }
}));
exports.register = (0, toolkit_1.createAsyncThunk)('user/register', (registerData, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.register(registerData);
        return response;
    }
    catch (error) {
        throw new Error(error.message);
    }
}));
exports.businessLogin = (0, toolkit_1.createAsyncThunk)('user/businessLogin', (token, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.businessLogin(token);
        return response;
    }
    catch (error) {
        throw new Error('Failed to login');
    }
}));
exports.logout = (0, toolkit_1.createAsyncThunk)('user/logout', (thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.logout();
        return response;
    }
    catch (error) {
        throw new Error('Logout Failed');
    }
}));
exports.getUserTokenWithRefreshToken = (0, toolkit_1.createAsyncThunk)('user/getUserTokenWithRefreshToken', (token, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.getUserTokenWithRefreshToken(token);
        return response;
    }
    catch (err) {
        throw new Error('Failed to fetch access token');
    }
}));
exports.getTokenWithRefreshToken = (0, toolkit_1.createAsyncThunk)('user/getTokenWithRefreshToken', (token, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.getTokenWithRefreshToken(token);
        return response;
    }
    catch (err) {
        throw new Error('Failed to fetch access token');
    }
}));
exports.fetch = (0, toolkit_1.createAsyncThunk)('user/fetch', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.fetchUsers(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch users');
    }
}));
exports.fetchForOwner = (0, toolkit_1.createAsyncThunk)('user/fetchForOwner', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.fetchUsersForOwner(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch users');
    }
}));
exports.fetchForFranchise = (0, toolkit_1.createAsyncThunk)('user/fetchForFranchise', (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.fetchUsersForFranchise(fetchPayload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch users');
    }
}));
exports.fetchUserById = (0, toolkit_1.createAsyncThunk)('user/fetchById', (thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.fetchUserById();
        return response;
    }
    catch (error) {
        throw new Error('Failed to fetch user');
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('user/create', (createData, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.createUser(createData);
        return response;
    }
    catch (error) {
        throw new Error('Failed to create user');
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('user/update', (updateData, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.updateUser(updateData);
        return response;
    }
    catch (error) {
        console.log(error);
        throw error;
    }
}));
exports.updateUserProfile = (0, toolkit_1.createAsyncThunk)('user/updateUserProfile', (updateData, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.updateProfile(updateData);
        return response;
    }
    catch (error) {
        throw new Error('Failed to update user');
    }
}));
exports.resetPassword = (0, toolkit_1.createAsyncThunk)('user/resetPassword', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.resetPassword(payload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to reset password');
    }
}));
exports.sendOtp = (0, toolkit_1.createAsyncThunk)('user/sendOtp', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.sendOtp(payload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to send otp');
    }
}));
exports.sendAdminOtp = (0, toolkit_1.createAsyncThunk)('user/sendAdminOtp', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.sendAdminOtp(payload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to send otp');
    }
}));
exports.verifyOtp = (0, toolkit_1.createAsyncThunk)('user/verifyOtp', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.verifyOtp(payload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to verify otp');
    }
}));
exports.verifyAdminOtp = (0, toolkit_1.createAsyncThunk)('user/verifyAdminOtp', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const userService = new userService_1.UserService(Env_1.APIPATHENV);
        const response = yield userService.verifyAdminOtp(payload);
        return response;
    }
    catch (error) {
        throw new Error('Failed to verify otp');
    }
}));
